$(document).ready(async function () {
    const CATEGORY_RULES = {
        1: { name: 'Advantage', stayPoints: 0, stayIndications: 1, nextId: 2 },
        2: { name: 'Premium', stayPoints: 20001, stayIndications: 3, nextId: 3 },
        3: { name: 'Elite', stayPoints: 80001, stayIndications: 10, nextId: null }
    };

    const CATEGORY_THEME = {
        1: { banner: 'category-advantage', accent: 'Advantage', color: '#0B7C84' },
        2: { banner: 'category-premium', accent: 'Premium', color: '#00468B' },
        3: { banner: 'category-elite', accent: 'Elite', color: '#66278F' }
    };

    const hasText = function (value) {
        return value !== null && value !== undefined && String(value).trim().length > 0;
    };

    const formatNumber = function (value) {
        const number = Number(value || 0);
        return number.toLocaleString('pt-BR');
    };

    // Dell fiscal quarters: Q1=Feb/Mar/Apr, Q2=May/Jun/Jul, Q3=Aug/Sep/Oct, Q4=Nov/Dec/Jan
    const getDellQuarterCloseDate = function () {
        const today = new Date();
        const month = today.getMonth();
        const year = today.getFullYear();

        if (month === 0) {
            // January → end of Q4 (Jan 31 same year)
            return new Date(year, 1, 0);
        } else if (month <= 3) {
            // Feb, Mar, Apr → end of Q1 (Apr 30)
            return new Date(year, 4, 0);
        } else if (month <= 6) {
            // May, Jun, Jul → end of Q2 (Jul 31)
            return new Date(year, 7, 0);
        } else if (month <= 9) {
            // Aug, Sep, Oct → end of Q3 (Oct 31)
            return new Date(year, 10, 0);
        } else {
            // Nov, Dec → end of Q4 (Jan 31 next year)
            return new Date(year + 1, 1, 0);
        }
    };

    const formatDate = function (dateValue) {
        if (!dateValue) {
            return '-';
        }

        const date = new Date(dateValue);
        if (Number.isNaN(date.getTime())) {
            return '-';
        }

        return date.toLocaleDateString('pt-BR');
    };

    const getProgramDescriptions = function () {
        return [
            {
                category: 'Premium',
                theme: 'premium',
                headerTitle: 'Benefícios categoria Premium',
                visibleFor: [1],
                sections: [
                    {
                        title: 'Mais Pontos, Mais Recompensas',
                        iconLabel: '<span class="material-symbols-outlined"> hotel_class </span>',
                        bullets: [
                            '<strong>Pontuação turbinada:</strong>',
                            '1,15 créditos por real em produtos Client',
                            '2 créditos por real em produtos Enterprise',
                            'Participação em campanhas sazonais de incentivos'
                        ]
                    },
                    {
                        title: 'Desenvolvimento Profissional Premium',
                        iconLabel: '<span class="material-symbols-outlined"> school </span>',
                        bullets: [
                            'Visitas técnicas e experiências únicas no Dell Solutions Center e no Microsoft Technology Center',
                            '<strong>Acesso direto</strong> aos executivos da Dell e grandes líderes do mercado',
                            'Acesso a treinamentos e EAD do Sebrae'
                        ]
                    },
                    {
                        title: 'Posicionamento Diferenciado no Programa',
                        iconLabel: '<span class="material-symbols-outlined"> bar_chart </span>',
                        bullets: [
                            'Categoria intermediária com vantagens ampliadas.',
                            'Todos os benefícios da categoria Advantage + <strong>diferenciais exclusivos</strong> que aceleram resultados e visibilidade.'
                        ]
                    }
                ]
            },
            {
                category: 'Elite',
                theme: 'elite',
                headerTitle: 'Benefícios categoria Elite',
                visibleFor: [2, 3],
                sections: [
                    {
                        title: 'Mais Pontos, Mais Recompensas',
                        iconLabel: '<span class="material-symbols-outlined"> star_shine </span>',
                        bullets: [
                            'Pontuação superacelerada:',
                            '2 créditos por real em produtos Client',
                            '3 créditos por real em produtos Enterprise',
                            'Participação em campanhas sazonais de incentivos'
                        ]
                    },
                    {
                        title: 'Reconhecimento Máximo',
                        iconLabel: '<span class="material-symbols-outlined"> military_tech </span>',
                        bullets: [
                            'Certificação oficial como <strong>Dell Expert Network Member</strong> (Após conclusão das trilhas de certificação e atingimento mínimo de 90% de acerto nas avaliações)',
                            'Seu perfil exibido na landing page como <strong>Professional Elite Certificado</strong>',
                            'Participação em <strong>certificações de parceiros</strong>'
                        ]
                    },
                    {
                        title: 'Vantagens exclusivas',
                        iconLabel: '<span class="material-symbols-outlined"> shield_person </span>',
                        bullets: [
                            'Acesso direto ao Tech Direct, a plataforma premium de suporte Dell',
                            '<strong>Consultoria gratuita</strong> do time de inteligência Dell para ajudar na construção de planos estratégicos de TI',
                            'Prioridade no suporte de seus clientes',
                            'Participação em consultorias exclusivas do Sebrae'
                        ]
                    }
                ]
            }
        ];
    };

    const ensureDynamicPanels = function (categoryId) {
        const benefitsByCategory = getProgramDescriptions().filter((item) => {
            return Array.isArray(item.visibleFor) && item.visibleFor.includes(categoryId);
        });

        if (!$('#home-benefits-modal').length) {
            const sections = benefitsByCategory.map((item) => {
                const sectionBlocks = item.sections.map((section) => {
                    const isMaterialIcon = section.iconLabel.indexOf('material-symbols-outlined') !== -1;
                    const iconClass = isMaterialIcon ? 'benefit-icon benefit-icon--material' : 'benefit-icon';
                    const list = section.bullets.map((benefit) => `<li>${benefit}</li>`).join('');

                    return ''
                        + '<section class="benefit-section">'
                        + `  <div class="${iconClass}" aria-hidden="true">${section.iconLabel}</div>`
                        + '  <div class="benefit-section-content">'
                        + `      <h5>${section.title}</h5>`
                        + `      <ul>${list}</ul>`
                        + '  </div>'
                        + '</section>';
                }).join('');

                return ''
                    + `<article class="benefits-model-card benefits-model-${item.theme}">`
                    + '  <header class="benefits-model-header">'
                    + `      <h4>${item.headerTitle}</h4>`
                    + '  </header>'
                    + '  <div class="benefits-model-body">'
                    + `      ${sectionBlocks}`
                    + '  </div>'
                    + '</article>';
            }).join('');

            $('body').append(
                ''
                + '<div class="home-benefits-modal" id="home-benefits-modal" aria-hidden="true">'
                + '  <div class="home-modal-overlay" data-dismiss-modal="true"></div>'
                + '  <div class="home-modal-dialog home-modal-dialog-benefits" role="dialog" aria-modal="true" aria-labelledby="home-benefits-title">'
                + '      <button type="button" class="home-modal-close" data-dismiss-modal="true" aria-label="Fechar modal">&times;</button>'
                + '      <h3 id="home-benefits-title" class="sr-only">Benefícios das categorias</h3>'
                + `      <div class="home-modal-content benefits-model-grid">${sections}</div>`
                + '  </div>'
                + '</div>'
            );
        } else {
            const sections = benefitsByCategory.map((item) => {
                const sectionBlocks = item.sections.map((section) => {
                    const isMaterialIcon = section.iconLabel.indexOf('material-symbols-outlined') !== -1;
                    const iconClass = isMaterialIcon ? 'benefit-icon benefit-icon--material' : 'benefit-icon';
                    const list = section.bullets.map((benefit) => `<li>${benefit}</li>`).join('');

                    return ''
                        + '<section class="benefit-section">'
                        + `  <div class="${iconClass}" aria-hidden="true">${section.iconLabel}</div>`
                        + '  <div class="benefit-section-content">'
                        + `      <h5>${section.title}</h5>`
                        + `      <ul>${list}</ul>`
                        + '  </div>'
                        + '</section>';
                }).join('');

                return ''
                    + `<article class="benefits-model-card benefits-model-${item.theme}">`
                    + '  <header class="benefits-model-header">'
                    + `      <h4>${item.headerTitle}</h4>`
                    + '  </header>'
                    + '  <div class="benefits-model-body">'
                    + `      ${sectionBlocks}`
                    + '  </div>'
                    + '</article>';
            }).join('');

            $('#home-benefits-modal .benefits-model-grid').html(sections);
        }

        if (!$('#program-regulation-drawer').length) {
            $('body').append(
                ''
                + '<div class="program-regulation-drawer" id="program-regulation-drawer" aria-hidden="true">'
                + '  <div class="drawer-overlay" data-close-drawer="true"></div>'
                + '  <aside class="drawer-panel" role="dialog" aria-modal="true" aria-label="Regulamento do Programa">'
                + '      <button type="button" class="drawer-close" data-close-drawer="true" aria-label="Fechar regulamento">&times;</button>'
                + '      <div class="drawer-body">'
                + '          <iframe src="/regulamento?embed=1" title="Regulamento do Programa" loading="lazy"></iframe>'
                + '      </div>'
                + '  </aside>'
                + '</div>'
            );
        }

    };

    const applyTrainingSectionTheme = function (categoryId) {
        const theme = CATEGORY_THEME[categoryId] || CATEGORY_THEME[1];
        const $section = $('#home-training-summary');

        if (!$section.length) {
            return;
        }

        $section.removeClass('category-advantage category-premium category-elite');
        $section.addClass(theme.banner);
    };

    const bindPanelEvents = function () {
        $(document).off('click.home-dashboard').on('click.home-dashboard', '[data-open-benefits-modal="true"]', function (event) {
            event.preventDefault();
            $('#home-benefits-modal').addClass('is-open').attr('aria-hidden', 'false');
        });

        $(document).on('click.home-dashboard', '[data-dismiss-modal="true"]', function () {
            $('#home-benefits-modal').removeClass('is-open').attr('aria-hidden', 'true');
        });

        $(document).on('click.home-dashboard', '[data-open-drawer="true"]', function (event) {
            event.preventDefault();
            $('#program-regulation-drawer').addClass('is-open').attr('aria-hidden', 'false');
        });

        $(document).on('click.home-dashboard', '[data-close-drawer="true"]', function () {
            $('#program-regulation-drawer').removeClass('is-open').attr('aria-hidden', 'true');
        });

        $(document).on('click.home-dashboard', '[data-tooltip-link="true"]', function (event) {
            event.preventDefault();
        });

    };

    const buildMetricCardDetails = function (metric, context) {
        const {
            categoryId,
            currentCategoryName,
            nextCategoryName,
            pointsToStay,
            indicationsToStay,
            pointsToUpgrade,
            indicationsToUpgrade,
            hasEnoughPointsToStay,
            hasEnoughIndicationsToStay,
            hasEnoughPointsToUpgrade,
            hasEnoughIndicationsToUpgrade,
            nextRule,
            currentTheme,
            nextTheme,
        } = context;

        const isPoints = metric === 'points';
        const metricMetForStay = isPoints ? hasEnoughPointsToStay : hasEnoughIndicationsToStay;
        const metricMetForUpgrade = isPoints ? hasEnoughPointsToUpgrade : hasEnoughIndicationsToUpgrade;
        const toStay = isPoints ? pointsToStay : indicationsToStay;
        const toUpgrade = isPoints ? pointsToUpgrade : indicationsToUpgrade;
        const unitLabel = isPoints ? 'pontos' : 'indicações';
        const achievementLabel = isPoints ? 'pontuação' : 'número de indicações';
        const stayVerb = isPoints ? 'atingir' : 'realizar';

        const styledCategory = function (name, theme) {
            return `<span style="color:${theme.color};font-weight:700">${name}</span>`;
        };

        const congratsStay = function () {
            return `Parabéns! Você atingiu a ${achievementLabel} necessária para continuar na categoria ${styledCategory(currentCategoryName, currentTheme)}.`;
        };

        const congratsUpgrade = function () {
            return `Parabéns! Você atingiu a ${achievementLabel} necessária para subir para a categoria ${styledCategory(nextCategoryName, nextTheme)}.`;
        };

        const stayMessage = function () {
            return `Para permanecer na categoria atual, é necessário ${stayVerb} mais <strong>${formatNumber(toStay)}</strong> ${unitLabel}.`;
        };

        const upgradeMessage = function () {
            return `Para conquistar a próxima categoria, sua meta é alcançar mais <strong>${formatNumber(toUpgrade)}</strong> ${unitLabel}.`;
        };

        const lines = [];

        if (categoryId === 1) {
            if (nextRule && metricMetForUpgrade) {
                lines.push(congratsUpgrade());
            } else if (nextRule && toUpgrade > 0) {
                lines.push(upgradeMessage());
            }

            return lines.map((line) => `<p>${line}</p>`).join('');
        }

        if (categoryId === 3) {
            if (metricMetForStay) {
                lines.push(congratsStay());
            } else if (toStay > 0) {
                lines.push(stayMessage());
            }

            return lines.map((line) => `<p>${line}</p>`).join('');
        }

        const bothStayMet = hasEnoughPointsToStay && hasEnoughIndicationsToStay;
        const onlyOneStayMet = (hasEnoughPointsToStay || hasEnoughIndicationsToStay) && !bothStayMet;

        if (onlyOneStayMet) {
            if (metricMetForStay) {
                lines.push(congratsStay());
            } else {
                if (toStay > 0) {
                    lines.push(stayMessage());
                }
                if (nextRule && toUpgrade > 0) {
                    lines.push(upgradeMessage());
                }
            }

            return lines.map((line) => `<p>${line}</p>`).join('');
        }

        if (!bothStayMet) {
            if (toStay > 0) {
                lines.push(stayMessage());
            }
            if (nextRule && toUpgrade > 0) {
                lines.push(upgradeMessage());
            }

            return lines.map((line) => `<p>${line}</p>`).join('');
        }

        if (nextRule) {
            const bothUpgradeMet = hasEnoughPointsToUpgrade && hasEnoughIndicationsToUpgrade;
            const onlyOneUpgradeMet = (hasEnoughPointsToUpgrade || hasEnoughIndicationsToUpgrade) && !bothUpgradeMet;

            if (onlyOneUpgradeMet) {
                if (metricMetForUpgrade) {
                    lines.push(congratsUpgrade());
                } else if (toUpgrade > 0) {
                    lines.push(upgradeMessage());
                }

                return lines.map((line) => `<p>${line}</p>`).join('');
            }

            if (bothUpgradeMet || metricMetForUpgrade) {
                lines.push(congratsUpgrade());
                return lines.map((line) => `<p>${line}</p>`).join('');
            }

            if (toUpgrade > 0) {
                lines.push(upgradeMessage());
            }

            return lines.map((line) => `<p>${line}</p>`).join('');
        }

        if (metricMetForStay) {
            lines.push(congratsStay());
        }

        return lines.map((line) => `<p>${line}</p>`).join('');
    };

    const renderConsultantDashboard = function (userResponse, account) {
        const user = userResponse && userResponse.data ? userResponse.data : userResponse;
        const categoryId = Number((account.category && account.category.id) || 1);
        const currentRule = CATEGORY_RULES[categoryId] || CATEGORY_RULES[1];
        const currentTheme = CATEGORY_THEME[categoryId] || CATEGORY_THEME[1];
        const currentCategoryName = (account.category && account.category.name) || currentRule.name;

        const nextRule = currentRule.nextId ? CATEGORY_RULES[currentRule.nextId] : null;
        const nextCategoryName = nextRule ? nextRule.name : null;

        const points = Number(account.points || 0);
        const indications = Number(account.indications || 0);
        const credits = Number(account.credits || 0);

        const pointsToStay = Math.max(currentRule.stayPoints - points, 0);
        const indicationsToStay = Math.max(currentRule.stayIndications - indications, 0);
        const pointsToUpgrade = nextRule ? Math.max(nextRule.stayPoints - points, 0) : 0;
        const indicationsToUpgrade = nextRule ? Math.max(nextRule.stayIndications - indications, 0) : 0;

        const hasEnoughPointsToStay = points >= currentRule.stayPoints;
        const hasEnoughIndicationsToStay = indications >= currentRule.stayIndications;
        const hasEnoughPointsToUpgrade = nextRule ? points >= nextRule.stayPoints : false;
        const hasEnoughIndicationsToUpgrade = nextRule ? indications >= nextRule.stayIndications : false;
        const nextTheme = nextRule ? CATEGORY_THEME[currentRule.nextId] : null;

        const messageContext = {
            categoryId,
            currentCategoryName,
            nextCategoryName,
            pointsToStay,
            indicationsToStay,
            pointsToUpgrade,
            indicationsToUpgrade,
            hasEnoughPointsToStay,
            hasEnoughIndicationsToStay,
            hasEnoughPointsToUpgrade,
            hasEnoughIndicationsToUpgrade,
            nextRule,
            currentTheme,
            nextTheme,
        };

        const pointsCardDetails = buildMetricCardDetails('points', messageContext);
        const indicationsCardDetails = buildMetricCardDetails('indications', messageContext);

        const styledCurrentName = `<strong style="color:${currentTheme.color}">${currentCategoryName}</strong>`;
        const styledNextName = nextTheme ? `<strong style="color:${nextTheme.color}">${nextCategoryName}</strong>` : '';

        const welcomeText = nextRule
            ? `Você faz parte da categoria ${styledCurrentName} e seu próximo nível é o ${styledNextName}. Entenda as vantagens de subir de nível `
            : `Você está na categoria ${styledCurrentName}. Mantenha seu nível. Entenda as vantagens de estar nesta categoria `;

        const linkText = nextRule ? 'clicando aqui' : 'clicando aqui';

        const lastOrderDate = account.last_valid_order_date
            ? account.last_valid_order_date
            : null;
        const quarterCloseDate = getDellQuarterCloseDate();
        const upgradeActivationDate = new Date(quarterCloseDate);
        upgradeActivationDate.setDate(upgradeActivationDate.getDate() + 15);

        const canUpgrade = nextRule && hasEnoughPointsToUpgrade && hasEnoughIndicationsToUpgrade;
        const upgradeAlert = canUpgrade
            ? '<div class="consultant-upgrade-alert">'
            + '  <span class="material-symbols-outlined" aria-hidden="true">target</span>'
            + `  <span class="consultant-upgrade-alert-text">Você já atingiu os pontos e indicações suficientes para subir para a categoria <strong style="color:${nextTheme.color}">${nextCategoryName}</strong>. Sua categoria nova será ativada até <strong>${formatDate(upgradeActivationDate)}</strong></span>`
            + '</div>'
            : '';

        const panel = ''
            + `<div class="consultant-dashboard ${currentTheme.banner}">`
            + '  <div class="consultant-dashboard-banner">'
            + `      <p>Você é um consultor <strong>${currentTheme.accent}</strong></p>`
            + '  </div>'
            + '  <div class="consultant-dashboard-content container">'
            + '      <div class="consultant-home-grid">'
            + '          <div class="consultant-home-main">'
            + `      <h2>Bem-vindo, <strong>${user && user.name ? user.name.split(' ')[0] : 'Consultor'}</strong></h2>`
            + '      <p class="consultant-dashboard-subtitle">'
            + `          ${welcomeText}<a href="#" data-open-benefits-modal="true">${linkText}</a>.`
            + '      </p>'
            + '      <div class="consultant-dashboard-cards">'
            + '          <a class="consultant-card" href="/pontuacao" data-tooltip="Clique para mais informações">'
            + '              <div class="card-main">'
            + '                  <div class="card-icon"><span class="material-symbols-outlined" aria-hidden="true">star</span></div>'
            + '                  <p class="card-label">Pontos</p>'
            + `                  <p class="card-value">${formatNumber(points)}</p>`
            + '              </div>'
            + '              <div class="card-details">'
            + `                  ${pointsCardDetails}`
            + '              </div>'
            + '          </a>'
            + '          <div class="consultant-cards-separator" aria-hidden="true">'
            + '              <span class="material-symbols-outlined">add_circle</span>'
            + '          </div>'
            + '          <a class="consultant-card" href="/pontuacao" data-tooltip="Clique para mais informações">'
            + '              <div class="card-main">'
            + '                  <div class="card-icon"><span class="material-symbols-outlined" aria-hidden="true">groups</span></div>'
            + '                  <p class="card-label">Indicações</p>'
            + `                  <p class="card-value">${formatNumber(indications)}</p>`
            + '              </div>'
            + '              <div class="card-details">'
            + `                  ${indicationsCardDetails}`
            + '              </div>'
            + '          </a>'
            + '      </div>'
            + '      <div class="consultant-credits-summary">'
            + '          <div class="consultant-credits-main">'
            + '              <span class="consultant-credits-icon" aria-hidden="true"><span class="material-symbols-outlined">workspace_premium</span></span>'
            + '              <div class="consultant-credits-text">'
            + `                  <p class="consultant-credits-value">${formatNumber(credits)}</p>`
            + '                  <p class="consultant-credits-label">Créditos disponíveis</p>'
            + '              </div>'
            + '          </div>'
            + '          <div class="consultant-credits-action">'
            + '              <p>Clique no botão abaixo e confira o seu extrato</p>'
            + '              <a href="/movimentacoes/extrato" class="consultant-credits-button">Extrato de movimentações</a>'
            + '          </div>'
            + '      </div>'
            + `      ${upgradeAlert}`
            + '          </div>'
            + '          <aside class="consultant-home-banner" id="home-banner-carousel" aria-label="Destaques"></aside>'
            + '      </div>'
            + '      <div class="consultant-dashboard-footer">'
            + '          <span class="material-symbols-outlined">calendar_today</span>'
            + `          <p>Os dados são atualizados semanalmente - última atualização em ${formatDate(lastOrderDate)}.</p>`
            + '          <span class="consultant-footer-break" aria-hidden="true"></span>'
            + '          <span class="material-symbols-outlined">help</span>'
            + '          <a href="#" data-tooltip-link="true" data-tooltip="• Pontos indicam seu desempenho no programa, sendo utilizados para mudança ou permanência de categoria.&#10;• Créditos podem ser utilizados para resgate de produtos.&#10;• A evolução de categoria acontece quando os critérios mínimos de pontos e indicações são atingidos. Após alcançar ambos os qualificadores, a mudança de categoria será aplicada na virada do próximo quarter.">Entenda a diferença entre pontos, créditos e o que é necessário para evoluir de categoria.</a>'
            + '          <span class="consultant-footer-break" aria-hidden="true"></span>'
            + '          <span class="material-symbols-outlined">info</span>'
            + '          <a href="#" data-open-drawer="true">Em caso de dúvidas, acesse o regulamento do programa.</a>'
            + '      </div>'
            + '  </div>'
            + '</div>';

        $('#banner-container').empty().removeClass('banner-home').addClass('consultant-dashboard-host').append(panel);
        $('#mouse-scroll').hide();

        renderHomeBanners();

        applyTrainingSectionTheme(categoryId);
        ensureDynamicPanels(categoryId);
        bindPanelEvents();
    };

    const renderHomeBanners = function () {
        const userId = localStorage.getItem('user_id');
        const $carousel = $('#home-banner-carousel');

        if (!$carousel.length) {
            return;
        }

        $.ajax({
            crossDomain: true,
            url: '/api/banners?active=1&per_page=50&user_id=' + userId,
            contentType: 'application/json',
            dataType: 'json',
            headers: {
                Authorization: localStorage.token,
            },
            success: function (result) {
                const isMobile = $(window).width() <= 767;
                const banners = (result.data || [])
                    .filter(function (banner) {
                        return banner.placement === 'home_consultor' && hasText(banner.image_url);
                    })
                    .slice(0, 3);

                if (!banners.length) {
                    $carousel.remove();
                    return;
                }

                for (let i = 0; i < banners.length; i++) {
                    const hasTitle = hasText(banners[i].name);
                    const hasUrl = hasText(banners[i].url);

                    const bannerImage = isMobile
                        ? (banners[i].image_mobile_url || banners[i].image_url)
                        : banners[i].image_url;

                    const linkOpen = hasUrl
                        ? '<a href="' + banners[i].url + '" ' + (banners[i].external ? 'target="_blank"' : '') + ' aria-label="' + (hasTitle ? banners[i].name : 'Saiba mais') + '">'
                        : '';
                    const linkClose = hasUrl ? '</a>' : '';

                    const html = '<div class="home-banner-slide">'
                        + linkOpen
                        + '<img class="home-banner-img" src="' + bannerImage + '" alt="' + (hasTitle ? banners[i].name : 'Banner') + '">'
                        + linkClose
                        + '</div>';

                    $carousel.append(html);
                }

                $carousel.slick({
                    dots: true,
                    arrows: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: false,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    rows: 0,
                    swipeToSlide: true,
                    touchThreshold: 10,
                    waitForAnimate: false,
                    cssEase: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
                });

                const homeBannerSlides = document.querySelectorAll('#home-banner-carousel .home-banner-slide.slick-slide:not(.slick-cloned)');
                homeBannerSlides.forEach((element, index) => {
                    element.setAttribute('role', 'group');
                    element.setAttribute('aria-label', `Banner ${index + 1} de ${homeBannerSlides.length}`);
                });
            }
        });
    };

    const renderBanners = function () {
        $.ajax({
            crossDomain: true,
            url: '/api/banners?active=1&per_page=5',
            contentType: 'application/json',
            dataType: 'json',
            headers: {
                Authorization: localStorage.token,
            },
            success: function (result) {
                window.banners = result.data;
                const isMobile = $(window).width() <= 767;

                for (let i = 0; i < result.data.length; i++) {
                    if (result.data[i].placement === 'home_consultor') {
                        continue;
                    }

                    const bannerImage = isMobile
                        ? (result.data[i].image_mobile_url || result.data[i].image_url)
                        : result.data[i].image_url;

                    if (!bannerImage) {
                        continue;
                    }

                    const hasTitle = hasText(result.data[i].name);
                    const hasDescription = hasText(result.data[i].description);
                    const hasUrl = hasText(result.data[i].url);
                    const wrapEntireBanner = hasUrl && !isMobile;

                    const linkOpen = wrapEntireBanner
                        ? '<a href="' + result.data[i].url + '" ' + (result.data[i].external ? 'target="_blank"' : '') + ' aria-label="' + (hasTitle ? result.data[i].name : 'Saiba mais') + '" style="display:block;position:relative;">'
                        : '';
                    const linkClose = wrapEntireBanner ? '</a>' : '';

                    let html = '<div class="banner-box">'
                        + linkOpen
                        + '<div class="banner-home-img">'
                        + '<img src="' + bannerImage + '" alt="' + result.data[i].name + '" style="object-fit: cover;object-position: center;width: 100%;height: 100%;">'
                        + '</div>'
                        + '<div class="container">';

                    if (hasTitle || hasDescription || (hasUrl && isMobile)) {
                        html += '<div class="col-lg-6 banner_text col-md-12">'
                            + '<div class="banner_text_iner">';

                        if (hasTitle) {
                            html += '<h2>' + result.data[i].name + '</h2>';
                        }

                        if (hasDescription) {
                            html += '<p>' + result.data[i].description + '</p>';
                        }

                        if (hasUrl && isMobile) {
                            html += '<div class="btn-box">'
                                + '<a href="' + result.data[i].url + '" class="btn-banner" ' + (result.data[i].external ? 'target="_blank"' : '') + ' role="button" alt="Saiba mais sobre ' + (hasTitle ? result.data[i].name : 'este conteúdo') + '" tabindex="0">Saiba mais</a>'
                                + '</div>';
                        }

                        html += '</div>'
                            + '</div>';
                    }

                    html += '</div>'
                        + linkClose
                        + '</div>';

                    $('#banner-container').append(html);
                }

                const startAt = result.data.length;

                $('.banner-home').slick({
                    dots: false,
                    infinite: true,
                    speed: 300,
                    slidesToShow: 1,
                    initialSlide: startAt,
                    adaptiveHeight: true,
                    autoplay: false,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                dots: true,
                                arrows: false,
                            }
                        }
                    ]
                });

                $('.banner-home').slick('slickGoTo', startAt);

                const bannerHomeSlides = document.querySelectorAll('.banner-home .banner-box.slick-slide:not(.slick-cloned)');
                bannerHomeSlides.forEach((element, index) => {
                    element.setAttribute('role', 'group');
                    element.setAttribute('aria-label', `Slide ${index + 1} de ${bannerHomeSlides.length}`);
                });

                $('#banner-container').on('click', 'a[href]', function (event) {
                    if (localStorage.getItem('user_id')) {
                        return;
                    }

                    var href = $(this).attr('href');

                    if (!href || href.charAt(0) !== '/') {
                        return;
                    }

                    if (href.indexOf('http://') === 0
                        || href.indexOf('https://') === 0
                        || href.indexOf('//') === 0
                        || href.indexOf('mailto:') === 0
                        || $(this).attr('target') === '_blank') {
                        return;
                    }

                    if (window.isProtectedRoute && window.isProtectedRoute(href)) {
                        event.preventDefault();
                        localStorage.path = href;
                        window.location.href = '/acesso';
                    }
                });
            }
        });
    };

    const isLogged = !!(localStorage.getItem('token') && localStorage.getItem('user_id'));

    if (isLogged && window.$getAccount && window.$getUser) {
        try {
            const response = await Promise.all([window.$getUser, window.$getAccount]);
            renderConsultantDashboard(response[0], response[1]);
            return;
        } catch (error) {
            console.warn('Falha ao montar dashboard da home. Exibindo banners padrão.', error);
        }
    }

    renderBanners();
});
